import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { Grid } from '@mui/material';
import { StyledSnackbar } from '../common/AppSnackbar';
import { Error, Link as LinkIcon } from '@mui/icons-material';
import FormTarget from './FormTarget';
import ComponentConfig from './ComponentConfig';
import { send_request } from '../../utils/Request';
import { CustomDialog } from '../Component/Dialog';
// import ComponentsSidebar from '../common/ComponentsSidebar'; // Removed - using inline field addition instead
import useProjectStore from '../ProjectCanvas/useProjectStore';
import FormBuilderContainer from './FormBuilderContainer';
import { getCurrentTime } from '../../utils/getCurrentTime';
import { searchForInnerFormPlaceholders } from '../../utils/InnerFormPlaceholders';
import ValidationErrors from '../pages/ComponentPageDialogs/ValidationErrors';
import 'react-image-crop/dist/ReactCrop.css';
import CircularProgress from '@mui/material/CircularProgress';
import { withParams } from '../../Routes';
import config from '../../config';
import { IndividualComponentLoader } from '../../utils/ComponentLoadingSkeleton';
import { createSaveEvent } from '../../utils/createSaveEvent';
import { saveCanvasEvent } from '../../utils/canvasApi';
import { ComponentFactory } from '../ProjectCanvas/ComponentRegistry';
import { FormContext } from '../pages/ComponentPane/ComponentPane';
import { FormSettingsDialog } from './FormDialogs/FormSettingsDialog';
import { FormLinkDialog } from './FormDialogs/FormLinkDialog';
import { FormExportDialog } from './FormDialogs/FormExportDialog';
import { FormEmbedDialog } from './FormDialogs/FormEmbedDialog';
import { FormComponentSettings } from './FormDialogs/FormComponentSettings';
import { FormStylingDialog } from './FormDialogs/FormStylingDialog';
import DiscardChangesButton from '../pages/ComponentPane/DiscardChangesButton';
import { injectMetadataFields } from '../../utils/buildComponentSavePayload';
import { getFormBuilderStore } from './useFormBuilderStore';
import useCanvasStore from '../pages/Canvas/useCanvasStore';

const fileService = config.FILE_SERVICE;
class FormBuilderPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      path: '',
      errors: [],
      submMsg: '',
      form_id: '',
      saveD: false,
      error: false,
      exportType: 0,
      loading: true,
      uploadIcon: '',
      saveStatus: '',
      iframeLink: '',
      formTitle: '',
      lastUpdate: '',
      embedWidth: 1080,
      embedHeight: 960,
      embedOpen: false,
      uploadedLogo: '',
      validationError: false,
      errorDialog: false,
      onBack: false,
      formSubmittedDateFormat: 'yyyy-MM-dd HH:mm:ss',
      prefixLabel: '',
      prefixLabelErrorMsg: '',
      canEditSubmission: true,
      canAddSubmission: false,
      canSaveSubmission: true,
      canAnnotateContent: false,
      canSubmitSubmission: true,
      canReadOnly: false,
      autoSave: false,
      displayMode: 'classic',
      uploadedCoverImage: null,
      coverImageSrc: '',
      coverImageCrop: {
        unit: '%',
        width: 30,
        aspect: 7 / 1,
      },
      logoSrc: '',
      logoCrop: {
        unit: '%',
        width: 30,
        aspect: 1,
      },
      croppedLogoUrl: '',
      loadingUpload: false,
      errorCoverImageMessage: '',
      errorLogoMessage: '',
      exposeMeta: false,
      // Component metadata settings
      metadataEnabled: false,
      startTimestampLabel: '',
      endTimestampLabel: '',
      metadataTimestampFormat: 'yyyy-MM-dd HH:mm:ss',
      linkedComponent: false,
      linkedComponents: [],
      redirectToExternalUrl: false,
      redirectUrl: '',
      isV2Schema: false,
      relatedSequentialForm: [],
      innerFormPlaceholders: [],
      externalPlaceholders: [],
      instruction: '',
      aiComponentBuilderOpen: false,
      status: null,
      openTestPanel: false,
      fetchTestOutput: false,
      compData: {},
      openSessionHistory: false,
      selectedHistorySession: false,
      resetHistory: false,
      isInAIDraft: false,

      instructions: {},
      showBuildPrompt: false,
      sidebarState: 'INITIAL_COMP_BUILD',
      isLoadedFromPane: false,
      isFullScreen: window.location.href.includes('fullScreen=true'),
      compSessionId: null,
      ranAIOnce: false,
    };
    this.Config = React.createRef();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const currentId = this.props.params.form_id
      ? this.props.params.form_id
      : this.props.component_id;

    if (this.state.form_id !== currentId) {
      if (currentId) {
        this.updateForm();
      } else {
        FormBuilderContainer.clearStorage();
      }
    }
  }

  onDiscard = () => {
    this.props.navigate(-1);
  };

  onBreadcrumb = path => {
    this.onSave();

    if (this.state.isLoadedFromPane) {
      this.props.handleClose(true);
    } else {
      if (useProjectStore.getState().production && !useProjectStore.getState().canvasView) {
        this.props.navigate(`/project/production/${this.props.params.id}`);
      } else {
        this.props.navigate(`/project/canvas/${this.props.params.id}`);
      }
    }
  };

  onSave = () => {
    if (!useProjectStore.getState().production) this.handleSubmit('published');
  };

  handleCancelSettings = setOpenSettings => {
    if (this.baseState) {
      this.setState({
        state: JSON.parse(this.baseState),
      });
      setOpenSettings(false);
    } else {
      setOpenSettings(false);
    }

    // If there isn't a link component selected, set back to default
    if (this.state.linkedComponent && this.state.linkedComponents.length === 0)
      this.setState({ linkedComponent: false });
  };

  /**
   * This function get the Form data from the Project.
   * This is the latest way of getting the Form data as the result of merging Form and Project
   * However, the previous way is still kept for backward compatibility
   */
  applyFormComponentData = (component, formId) => {
    if (!component?.componentData) return false;

    const cData = component.componentData;
    const isV2 = cData.schemaVersion === 2 || Array.isArray(cData.pages);
    const rData = isV2 ? cData : cData.data;
    if (!rData?.pages) return false;

    FormBuilderContainer._componentId = formId;
    FormBuilderContainer.reloadTemplate(rData.pages, Object.keys(rData.pages || {}).length);

    const coverImageCrop = {
      unit: '%',
      width: 30,
      aspect: 7 / 1,
    };

    document.title = `${rData.formTitle ? rData.formTitle : 'Untitled'} | Workflow86`;

    this.setState({
      form_id: formId,
      isV2Schema: isV2,
      lastUpdate: cData.lastModified,
      uploadIcon: rData.form_logo,
      formTitle: rData.formTitle,
      submMsg: rData.submMsg ? rData.submMsg : '',
      canAddSubmission: rData.canAddSubmission ? rData.canAddSubmission : false,
      canSaveSubmission:
        rData.canSaveSubmission !== undefined ? rData.canSaveSubmission : true,
      canAnnotateContent: false,
      autoSave: rData.autoSave !== undefined ? rData.autoSave : false,
      displayMode: rData.displayMode !== undefined ? rData.displayMode : 'classic',
      canSubmitSubmission:
        rData.canSubmitSubmission !== undefined ? rData.canSubmitSubmission : true,
      canEditSubmission: rData.canEditSubmission != null ? rData.canEditSubmission : true,
      canReadOnly: rData.canReadOnly ? rData.canReadOnly : false,
      prefixLabel: component.prefixLabel,
      exposeMeta: component.prefixLabel && component.prefixLabel != '' ? true : false,
      formSubmittedDateFormat: rData.formSubmittedDateFormat || 'yyyy-MM-dd HH:mm:ss',
      // Load component metadata settings
      metadataEnabled: component.metadataEnabled || false,
      startTimestampLabel: component.startTimestampLabel || '',
      endTimestampLabel: component.endTimestampLabel || '',
      metadataTimestampFormat: component.metadataTimestampFormat || 'yyyy-MM-dd HH:mm:ss',
      uploadedCoverImage:
        rData.coverImage !== undefined ? rData.coverImage.uploaded || null : null,
      coverImageSrc: rData.coverImage !== undefined ? rData.coverImage.src : '',
      coverImageCrop: rData.coverImage !== undefined ? rData.coverImage.crop : coverImageCrop,
      uploadedLogo: rData.logo !== undefined ? rData.logo.uploaded : '',
      linkedComponent: rData.linkedComponent ? true : false,
      linkedComponents: rData.linkedComponents,
      redirectToExternalUrl: rData.redirectToExternalUrl ? true : false,
      redirectUrl: rData.redirectUrl ? rData.redirectUrl : '',
      instruction: component.description ? component.description : this.state.description,
      instructions: component.instructions ? component.instructions : this.state.instructions,
    });

    this.props.onLastModifiedChanged(cData.lastModified);
    this.props.onComponentDescriptionChanged(component?.description || '');
    this.baseState = JSON.stringify(this.state); //enable Cancel button for the FormSettings dialog
    this.setState({ loading: false });
    this.setLast;
    return true;
  };

  getCachedProjectComponent = formId => {
    const component = useProjectStore
      .getState()
      .components?.find(comp => comp.componentId === formId);
    if (!component) return null;

    const componentData = component.rawComponentData || component.componentData;
    return componentData ? { ...component, componentData } : null;
  };

  updateFormFromProject = async () => {
    const formId = this.props.params.form_id ? this.props.params.form_id : this.props.component_id;

    let version = null;
    if (useProjectStore.getState().production) version = useProjectStore.getState().publishedVersion;
    else version = useProjectStore.getState().draftVersion;
    if (formId) {
      await this.setCompData();

      const cachedComponent = this.getCachedProjectComponent(formId);
      if (this.applyFormComponentData(cachedComponent, formId)) return Promise.resolve();

      return send_request(
        `project-service/project/component/query/${formId}/at-version/${version}`,
        '',
        {}
      )
        .then(async response => {
          if (response.data && response.data.components) {
            this.applyFormComponentData(response.data.components[0], formId);
          }

          if (!this.state.formTitle) {
            this.setState({ formTitle: useProjectStore.getState().componentName });
          }
        })
        .catch(err => {
          this.setState({ loading: false });
          throw Error(err.message);
        });
    }
  };

  setCompData = async () => {
    const formId = this.props.params.form_id ? this.props.params.form_id : this.props.component_id;

    try {
      if (!useProjectStore.getState().components) return;

      let comp = useProjectStore.getState().components.find(comp => comp.componentId === formId);

      // Set type
      let type = '';
      if (comp) type = comp.type;
      else type = 'form';

      let compNode = ComponentFactory[type];
      if (!compNode) return;

      let res = {
        id: formId,
        type: 'component',
        data: {
          ...compNode,
          type: type,
        },
      };

      this.setState({ compData: res });
    } catch (e) {
      console.log(e);
    }
  };

  updateForm = isInnerSave => {
    const projectId = this.props.params.id;

    const formId = this.props.params.form_id ? this.props.params.form_id : this.props.component_id;

    if (useProjectStore.getState().draftVersion == undefined) {
      // We need to add the set timeout so it places the navigate
      // at the end of the JS event loop
      setTimeout(() => {
        return this.props.navigate(`/project/canvas/${projectId}`);
      }, 0);
    } else {
      if (!isInnerSave) FormBuilderContainer.clearStorage();

      if (formId) {
        this.updateFormFromProject()
          .then(() => {
            //get linked components
            this.getLinkedComponents();

            if (!FormBuilderContainer.pages || FormBuilderContainer.pages.length == 0) {
              /**
               * the Form could not be found in the Project.
               * Then, we will try the Form DB.
               */
              send_request('form-builder/form', '', { form_id: formId }, 'get')
                .then(res => {
                  const result = res.data.data;
                  FormBuilderContainer._componentId = formId;
                  FormBuilderContainer.reloadTemplate(result.pages, Object.keys(result.pages || {}).length);
                  this.setState({
                    form_id: formId,
                    lastUpdate: result.created_at,
                  });
                  this.props.onLastModifiedChanged(result.created_at);
                  this.baseState = JSON.stringify(this.state); //enable Cancel button for the FormSettings dialog
                  this.setState({ loading: false });
                })

                .catch(e => {
                  this.setState({ loading: false });
                  return;
                });
              send_request('form-builder/form_meta', '', { form_id: formId }, 'get')
                .then(async res => {
                  const coverImageCrop = {
                    unit: '%',
                    width: 30,
                    aspect: 7 / 1,
                  };

                  this.setState({
                    uploadIcon: res.data.data.form_logo,
                    formTitle: res.data.data.formTitle,
                    submMsg: res.data.data.submMsg ? res.data.data.submMsg : '',
                    canAddSubmission: res.data.data.canAddSubmission
                      ? res.data.data.canAddSubmission
                      : false,
                    canSaveSubmission:
                      res.data.data.canSaveSubmission !== undefined
                        ? res.data.data.canSaveSubmission
                        : true,
                    canAnnotateContent: false,
                    canSubmitSubmission:
                      res.data.data.canSubmitSubmission !== undefined
                        ? res.data.data.canSubmitSubmission
                        : true,
                    canEditSubmission:
                      res.data.data.canEditSubmission != null
                        ? res.data.data.canEditSubmission
                        : true,
                    canReadOnly: res.data.data.canReadOnly ? res.data.data.canReadOnly : false,
                    uploadedCoverImage:
                      res.data.data.coverImage !== undefined
                        ? res.data.data.coverImage.uploaded || null
                        : null,
                    coverImageCrop:
                      res.data.data.coverImage !== undefined
                        ? res.data.data.coverImage.crop
                        : coverImageCrop,
                    coverImageSrc:
                      res.data.data.coverImage !== undefined ? res.data.data.coverImage.src : '',
                    uploadedLogo:
                      res.data.data.logo !== undefined ? res.data.data.logo.uploaded : '',
                  });

                  if (!this.state.formTitle) {
                    this.setState({
                      formTitle: useProjectStore.getState().componentName,
                      ranAIOnce: false,
                    });
                  }
                })

                .catch(e => {
                  return;
                });
            }
          })
          .then(() => {
            //Search for inner form placeholders

            this.setState({
              innerFormPlaceholders: searchForInnerFormPlaceholders(FormBuilderContainer.pages),
            });
          });
      }
    }
  };

  getLinkedComponents() {
    const formId = this.props.params.form_id ? this.props.params.form_id : this.props.component_id;

    send_request('project-service/project/find_related_sequential_forms/' + formId, '', {}).then(
      resp => {
        if (resp && resp.data) {
          let k = Object.keys(resp.data);
          let SFormsList = [];
          for (let a = 0; a < k.length; a++) {
            SFormsList.push({
              label:
                resp.data[k[a]].componentName && resp.data[k[a]].componentName != ''
                  ? resp.data[k[a]].componentName
                  : k[a],
              componentId: k[a],
            });
          }

          let lc = [];

          if (this.state.linkedComponents) {
            for (let a = 0; a < this.state.linkedComponents.length; a++) {
              if (resp.data[this.state.linkedComponents[a]]) {
                lc.push({
                  label:
                    resp.data[this.state.linkedComponents[a]].componentName &&
                    resp.data[this.state.linkedComponents[a]].componentName != ''
                      ? resp.data[this.state.linkedComponents[a]].componentName
                      : this.state.linkedComponents[a],
                  componentId: this.state.linkedComponents[a],
                });
              }
            }
          }

          this.setState({
            relatedSequentialForm: SFormsList,
            linkedComponents: lc,
          });
        }
      }
    );
  }

  componentDidMount() {
    const id = this.props.params.form_id ? this.props.params.form_id : this.props.component_id;

    const store = getFormBuilderStore(id);
    store.setState({ loaded: true });
    store.getState().registerSave(async (overrides = {}) => {
      const result = await this.handleSubmit('published', false, overrides.sessionId);
      if (result?.saveStatus == 200) {
        this.props.showSuccess?.({}, {
          executeTest: overrides.executeTest,
          sessionId: overrides.sessionId,
        });
        this.props.onLastModifiedChanged?.(this.state.lastModified);
      }
      useProjectStore.setState({ savedComponent: true });
      return result;
    });
    this._formStoreId = id;

    this._unsubContainer = FormBuilderContainer.subscribe(() => this.forceUpdate());

    // Determine the id based on whether form_id is present
    const isLoadedFromPane = this.props.params.form_id ? false : true;

    // Find the component in ProjectStore using the determined id
    const component = useProjectStore.getState().components.find(c => c.componentId === id);
    // Set state based on the found component, with fallbacks for instruction and instructions
    this.setState({
      instruction: component?.description || '',
      instructions: component?.instructions || '',
      form_id: id,
      loading: true,
      isLoadedFromPane: isLoadedFromPane,
    });

    if (isLoadedFromPane) this.props.setChildTemplateLoaded(true);

    // Fetch global variables (account-level placeholders)
    this.fetchGlobalVariables();

    // Continue with form update and validation processes
    this.updateForm();
    this.validate();
  }

  validate = () => {
    const formId = this.props.params.form_id ? this.props.params.form_id : this.props.component_id;

    useProjectStore.getState().errors.map((error, index) => {
      if (error.component.component_id == formId) this.state.errors.push(error);
    });
    this.setState({ errors: this.state.errors });
    if (this.state.errors.length > 0) this.setState({ validationError: true });
  };

  /**
   * Fetches global variables from the backend.
   * Global variables are account-level placeholders accessible across all workflows,
   * including in form question configuration (prefill, visibility, etc.).
   */
  fetchGlobalVariables = async () => {
    const projectId = this.props.params.id;

    if (!projectId) return;

    try {
      const url = `component-service/placeholder/global/${projectId}`;
      const response = await send_request(url, '', '', 'get');

      if (response && response.data && response.data.placeholders) {
        const placeholders = response.data.placeholders.map(p => ({
          key: p.key,
          type: p.type || 'global',
          value: p.key,
        }));
        this.setState({ externalPlaceholders: placeholders });
      }
    } catch (error) {
      console.error('Error fetching global variables:', error);
    }
  };

  onDone = e => {
    if (!useProjectStore.getState().production) {
      this.Config.current.handleSave();
      this.handleSubmit('published');
    }
    FormBuilderContainer.onEdit = false;
    FormBuilderContainer.editTarget = '';
    FormBuilderContainer.onSave = false;
    this.setInnerPlaceholders();
    this.forceUpdate();
  };

  handleSubmit = (status, executingTest, sessionId) => {
    if (this.state.isInAIDraft || this.state.loading) {
      FormBuilderContainer.onEdit = false;
      FormBuilderContainer.editTarget = '';
      FormBuilderContainer.onSave = false;
      return;
    }
    function isDataURL(s) {
      return !!s.match(isDataURL.regex);
    }
    isDataURL.regex =
      /^\s*data:([a-z]+\/[a-z0-9\-\+]+(;[a-z\-]+\=[a-z0-9\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
    try {
      let data = FormBuilderContainer.saveTemplate();
      const pages = data['pages'];

      const hasContent = Array.isArray(pages)
        ? pages.some(p => p.fields?.length > 0)
        : pages && Object.keys(pages).some(k => {
            const pg = pages[k];
            return pg?.components?.length > 0 || pg?.fields?.length > 0;
          });
      if (!hasContent) {
        return Promise.resolve({ saveStatus: 204, skipped: true });
      }

      const logoUploaded = {
        name: this.state.uploadedLogo.name,
      };

      let src = '';
      if (this.state.uploadedCoverImage && this.state.uploadedCoverImage.id != undefined) {
        src = `${fileService.QUERY_URL}/${this.state.uploadedCoverImage.id}`;
      }

      const coverImage = {
        uploaded: this.state.uploadedCoverImage,
        crop: this.state.coverImageCrop,
        src: src,
      };

      const logo = {
        uploaded: logoUploaded,
      };

      let form_template = {};
      form_template['pages'] = pages;
      form_template['status'] = status;
      form_template['submMsg'] = this.state.submMsg;
      form_template['form_id'] = this.state.form_id;
      form_template['formLength'] = Object.keys(pages).length;
      form_template['form_logo'] = this.state.uploadIcon;
      form_template['formTitle'] = useProjectStore.getState().componentName;
      form_template['canAddSubmission'] = this.state.canAddSubmission;
      form_template['canSaveSubmission'] = this.state.canSaveSubmission;
      form_template['canAnnotateContent'] = false;
      form_template['autoSave'] = this.state.autoSave;
      form_template['displayMode'] = this.state.displayMode;
      form_template['canSubmitSubmission'] = this.state.canSubmitSubmission;
      form_template['canEditSubmission'] = this.state.canEditSubmission;
      form_template['canReadOnly'] = this.state.canReadOnly;
      form_template['coverImage'] = coverImage;
      form_template['logo'] = logo;

      // Update page title
      document.title = `${this.state.formTitle ? this.state.formTitle : 'Untitled'} | Workflow86`;

      //if there is new logo uploaded
      if (this.state.uploadedLogo && this.state.uploadedLogo.name)
        form_template['logo_url'] = this.state.uploadIcon;

      form_template['formSubmittedDateFormat'] = this.state.formSubmittedDateFormat;

      form_template['linkedComponent'] = this.state.linkedComponent;
      if (this.state.linkedComponents) {
        let lc = [];
        for (let a = 0; a < this.state.linkedComponents.length; a++) {
          lc.push(this.state.linkedComponents[a].componentId);
        }
        form_template['linkedComponents'] = lc;
      }
      form_template['redirectToExternalUrl'] = this.state.redirectToExternalUrl;
      form_template['redirectUrl'] = this.state.redirectUrl;

      const componentData = this.state.isV2Schema
        ? { schemaVersion: 2, ...form_template, name: useProjectStore.getState().componentName, lastModified: getCurrentTime() }
        : { data: form_template, name: useProjectStore.getState().componentName, lastModified: getCurrentTime() };
      let submitData = injectMetadataFields({
        componentData,
        componentId: this.state.form_id,
        prefixLabel: this.state.prefixLabel,
        type: 'form',
        description: useProjectStore.getState().componentDescription,
        instruction: this.state.instruction,
        status: this.state.status,
      });

      if (sessionId) submitData['sessionId'] = sessionId;
      if (this.state.isInAIDraft) {
        submitData['sessionId'] = this.state.compSessionId;
      }

      return send_request('component-service/form/data', submitData, '', 'POST')
        .then(response => {
          this.setState({
            saveD: true,
            saveStatus: 200,
            lastUpdate: getCurrentTime(),
          });
          this.props.onLastModifiedChanged(getCurrentTime());
          useProjectStore.setState({ savedComponent: true });

          // Update rawComponentData in project store so inline preview & placeholders refresh
          const comps = useProjectStore.getState().components;
          if (comps) {
            const idx = comps.findIndex(c => c.componentId === this.state.form_id);
            const updated = [...comps];
            if (idx !== -1) {
              updated[idx] = { ...updated[idx], rawComponentData: submitData.componentData };
            } else {
              // New form not yet in components array — add it so preview + placeholders work
              updated.push({
                componentId: this.state.form_id,
                type: submitData.type || 'form',
                rawComponentData: submitData.componentData,
                nextComponents: [],
              });
            }
            useProjectStore.setState({ components: updated });
          }

          // Sync schemaVersion to canvas node so chip updates without reload
          const sv = submitData.componentData?.schemaVersion;
          if (sv != null) {
            try {
              useCanvasStore.getState().setNodesFn(nodes =>
                nodes.map(n =>
                  n.id === this.state.form_id && n.data?.schemaVersion !== sv
                    ? { ...n, data: { ...n.data, schemaVersion: sv } }
                    : n
                )
              );
            } catch (e) {
              console.warn('[FormBuilderPage] failed to sync schemaVersion to canvas node:', e);
            }
          }

          FormBuilderContainer.onEdit = false;
          FormBuilderContainer.editTarget = '';
          FormBuilderContainer.onSave = false;

          if (this.state.openTestPanel && !executingTest) this.setState({ fetchTestOutput: true });
          return { saveStatus: 200 };
        })
        .catch(err => {
          FormBuilderContainer.onEdit = false;
          FormBuilderContainer.editTarget = '';
          FormBuilderContainer.onSave = false;
          this.setState({ saveD: true, saveStatus: 500 });
          return { saveStatus: 500 };
        });
    } catch (e) {
      FormBuilderContainer.onSave = false;
      this.setState({ saveD: true, saveStatus: 500 });
      return { saveStatus: 500 };
    } finally {
      if (sessionId) {
        // reload form to ensure correct state comes up
        setTimeout(() => {
          this.updateForm(true);
        }, 1000);
      }
    }
  };

  goBackToCanvas = () => {
    window.location.href = `/project/canvas/${this.props.params.id}`;
  };

  deleteItem = id => {
    let cards = [...FormBuilderContainer.pages];
    let result = cards.filter(item => item.id !== id);
    FormBuilderContainer.pages = result;
    FormBuilderContainer.notify();
  };

  onImageDrop = async (files, type) => {
    this.setState({
      loadingUpload: true,
    });
    let project_id = this.props.params.id;

    const formId = this.props.params.form_id ? this.props.params.form_id : this.props.component_id;

    if (project_id) {
      let formData = new FormData();
      formData.append('file', files[0]);
      formData.append('formId', formId);
      formData.append('projectId', project_id);

      const json = await send_request(
        'component-service/form/upload-cover-image',
        formData,
        '',
        'POST',
        {
          'content-type': 'multipart/form-data',
        }
      ).catch(err => {
        this.setState({
          loadingUpload: false,
        });
        throw err;
      });

      if (json && json.data) {
        if (files && files.length > 0) {
          const coverImageUploaded = {
            name: json.data.fileName,
            id: json.data.id,
          };
          const reader = new FileReader();
          if (type === 'coverImage') {
            reader.addEventListener('load', () =>
              this.setState({
                coverImageSrc: reader.result,
                uploadedCoverImage: coverImageUploaded,
                loadingUpload: false,
                errorCoverImageMessage: '',
              })
            );
          } else if (type === 'logo') {
            reader.addEventListener('load', () =>
              this.setState({
                uploadedLogo: files[0],
                loadingUpload: false,
                errorLogoMessage: '',
              })
            );
          }
          reader.readAsDataURL(files[0]);
        }
      }
    }
  };

  previewIcon = uploadedLogo => {
    const reader = file => {
      if (Object.keys(file).length > 0) {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onload = () => resolve(fileReader.result);
          fileReader.readAsDataURL(file);
        });
      }
    };
    if (uploadedLogo !== '') {
      if (Object.keys(uploadedLogo).length > 0) {
        reader(uploadedLogo).then(result => {
          this.setState({ uploadIcon: result });
        });
      }
    }
  };

  exportFormDataAsCsv = () => {
    var project_id = this.props.params.id;
    var form_id = this.state.form_id;
    send_request(
      'project-service/project-session/download_form_submission_csv/' + project_id + '/' + form_id,
      {},
      '',
      'GET',
      {},
      'arraybuffer'
    )
      .then(response => {
        const filename = 'submissionData.csv';
        var blob = new Blob([response.data]);
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
      })
      .catch(err => console.log(err));
  };

  exportFormDataAsXLSX = () => {
    var project_id = this.props.params.id;
    var form_id = this.state.form_id;
    send_request(
      'project-service/project-session/download_form_submission_xlsx/' + project_id + '/' + form_id,
      {},
      '',
      'GET',
      {},
      'arraybuffer'
    )
      .then(response => {
        const filename = 'submissionData.xlsx';
        var blob = new Blob([response.data]);
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
      })
      .catch(err => console.log(err));
  };

  generateCode = () => {
    const { embedWidth, embedHeight } = this.state;

    let link = config.buildFormUrl(`/form/${this.state.form_id}`);
    let iframeLink = `<iframe src="${link}" width="${embedWidth}" height="${embedHeight}" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>`;

    this.setState({
      iframeLink,
    });
  };

  onImageLoaded = (image, type) => {
    if (type === 'coverImage') {
      this.coverImageRef = image;
    } else if (type === 'logo') {
      this.logoRef = image;
    }
  };

  onCropComplete = (crop, type) => {
    this.makeClientCrop(crop, type);
  };

  onCropChange = (crop, type) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });
    if (type === 'coverImage') {
      crop.aspect = 7 / 1;
      this.setState({ coverImageCrop: crop });
    } else if (type === 'logo') {
      crop.aspect = 1;
      this.setState({ logoCrop: crop });
    }
  };

  async makeClientCrop(crop, type) {
    if (type === 'coverImage') {
      if (this.coverImageRef && crop.width && crop.height) {
        await this.getCroppedImg(this.coverImageRef, crop);
      }
    }
  }

  getCroppedImg(image, crop) {
    image.crossOrigin = 'anonymous';
    const canvas = document.createElement('canvas');
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    this.setState({
      coverImageCrop: {
        aspect: 7 / 1,
        scaleX: scaleX,
        scaleY: scaleY,
        width: crop.width,
        height: crop.height,
        x: crop.x,
        y: crop.y,
        naturalWidth: crop.width * scaleX,
        naturalHeight: crop.height * scaleY,
        naturalX: crop.x * scaleX,
        naturalY: crop.y * scaleY,
      },
    });
  }

  onDropRejected = type => {
    if (type === 'coverImage') {
      this.setState({
        errorCoverImageMessage: 'Maximum file upload size is 2MB',
      });
    } else if (type === 'logo') {
      this.setState({
        errorLogoMessage: 'Maximum file upload size is 2MB',
      });
    }
  };

  onLogoDrop(files) {
    this.previewIcon(files[0]);
    this.setState({
      uploadedLogo: files[0],
      errorLogoMessage: '',
    });
  }

  deleteCoverImage = async () => {
    const { uploadedCoverImage } = this.state;
    if (!uploadedCoverImage || !uploadedCoverImage.id) return;
    const data = [];
    data.push(uploadedCoverImage.id);
    let requestBody = {
      deleteList: data,
      project_id: this.props.params.id,
    };

    const json = await send_request(
      `project-service/project/file-library/deletes`,
      requestBody,
      '',
      'POST'
    ).catch(err => {
      throw Error(err.message);
    });

    if (json && json.status == '200') {
      this.setState({
        uploadedCoverImage: null,
        coverImageSrc: '',
        coverImageCrop: {
          unit: '%',
          width: 30,
          aspect: 7 / 1,
        },
      });

      this.handleSubmit('published');
    }
  };

  setInnerPlaceholders = () => {
    //Search for inner form placeholders
    this.setState({
      innerFormPlaceholders: searchForInnerFormPlaceholders(FormBuilderContainer.pages),
    });
  };

  updateComponent = async (discardBuildInstruction = false, discardEditInstructions = false) => {
    const formId = this.props.params.form_id ? this.props.params.form_id : this.props.component_id;

    let eventData = {
      componentId: formId,
      instruction: this.state.instruction,
      discardBuildInstructions: discardBuildInstruction,
      discardEditInstructions: discardEditInstructions,
    };

    let saveEvent = createSaveEvent(
      'UPDATE_COMPONENT',
      useProjectStore.getState().project_id,
      { x: null, y: 0.0, zoom: 0.0 },
      [],
      eventData
    );

    //send event
    await saveCanvasEvent(useProjectStore.getState().project_id, saveEvent)
      .then(response => {
        if (response.data && response.data.updated) {
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  setComponentInstruction = async instruction => {
    this.setState({ instruction: instruction });
  };

  removeForceStartTestParams = async () => {
    if (this.props.queryParams) {
      this.props.queryParams.delete('force_start');
      this.props.queryParams.delete('selectedSession');
      this.props.navigate({ search: this.props.queryParams.toString() });
    } else {
      const params = new URLSearchParams(window.location.search);
      params.delete('force_start');
      params.delete('selectedSession');
      this.props.navigate({ search: params.toString() });
    }
  };

  componentWillUnmount() {
    if (this._unsubContainer) this._unsubContainer();
  }

  handleExpand = () => {
    this.setState({ isFullScreen: true });
    this.props.handleExpand();
  };

  handleCollapse = () => {
    this.setState({ isFullScreen: false, openTestPanel: false });
    this.props.handleCollapse();
  };

  render() {
    const { coverImageSrc, coverImageCrop } = this.state;
    const routes = [
      {
        path: `/project/canvas/${this.props.params.id}`,
        breadcrumbName: 'Workflow Canvas',
      },
      {
        breadcrumbName: 'Form Builder',
      },
    ];

    return (
      <FormContext.Consumer>
        {({ settings, formLink, formExport, formEmbed, componentSettings, styling }) => {
          const [openSettings, setOpenSettings] = settings;
          const [openFormLink, setOpenFormLink] = formLink;
          const [openExport, setOpenExport] = formExport;
          const [openEmbed, setOpenEmbed] = formEmbed;
          const [openComponentSettings, setOpenComponentSettings] = componentSettings;
          const [openUploadDialog, setOpenUploadDialog] = styling;

          return (
            <Grid container>
              {this.state && !this.state.loading ? (
                <Grid item xs>
                  <Grid container item direction="column" xs={12}>
                    <ValidationErrors
                      open={this.state.errorDialog}
                      close={() => {
                        this.setState({ errorDialog: false, onBack: false });
                      }}
                      errors={this.state.errors}
                      save={() => {
                        if (this.state.onBack) {
                          let path = `/project/canvas/${this._project_id}`;
                          this.props.navigate(path);
                        }
                        this.setState({ errorDialog: false });
                        this.handleSubmit('published');
                      }}
                    />

                    <FormEmbedDialog
                      openEmbed={openEmbed}
                      setOpenEmbed={setOpenEmbed}
                      generateCode={this.generateCode}
                      iframeLink={this.state.iframeLink}
                      embedHeight={this.state.embedHeight}
                      embedWidth={this.state.embedWidth}
                      setEmbedHeight={height => {
                        this.setState({ embedHeight: height });
                      }}
                      setEmbedWidth={width => {
                        this.setState({ embedWidth: width });
                      }}
                    />

                    <FormComponentSettings
                      isForm={true}
                      openComponentSettings={openComponentSettings}
                      setOpenComponentSettings={setOpenComponentSettings}
                      exposeMeta={this.state.exposeMeta}
                      prefixLabel={this.state.prefixLabel}
                      formSubmittedDateFormat={this.state.formSubmittedDateFormat}
                      prefixLabelErrorMsg={this.state.prefixLabelErrorMsg}
                      formId={this.state.form_id}
                      setExposeMeta={val => {
                        this.setState({ exposeMeta: val });
                      }}
                      setPrefixLabel={val => {
                        this.setState({ prefixLabel: val });
                      }}
                      setPrefixLabelErrorMsg={val => {
                        this.setState({ prefixLabelErrorMsg: val });
                      }}
                      handleSubmit={this.handleSubmit}
                      setFormSubmittedDateFormat={val => {
                        this.setState({ formSubmittedDateFormat: val });
                      }}
                      // Component metadata props
                      metadataEnabled={this.state.metadataEnabled}
                      startTimestampLabel={this.state.startTimestampLabel}
                      endTimestampLabel={this.state.endTimestampLabel}
                      metadataTimestampFormat={this.state.metadataTimestampFormat}
                      setMetadataEnabled={val => {
                        this.setState({ metadataEnabled: val });
                      }}
                      setStartTimestampLabel={val => {
                        this.setState({ startTimestampLabel: val });
                      }}
                      setEndTimestampLabel={val => {
                        this.setState({ endTimestampLabel: val });
                      }}
                      setMetadataTimestampFormat={val => {
                        this.setState({ metadataTimestampFormat: val });
                      }}
                    />

                    <FormLinkDialog
                      openFormLink={openFormLink}
                      setOpenFormLink={setOpenFormLink}
                      formId={this.state.form_id}
                    />
                    <FormSettingsDialog
                      isForm={true}
                      openSettings={openSettings}
                      setOpenSettings={val => setOpenSettings(val)}
                      linkedComponent={this.state.linkedComponent}
                      setLinkedComponents={val => this.setState({ linkedComponents: val })}
                      setLinkedComponent={val => this.setState({ linkedComponent: val })}
                      relatedSequentialForm={this.state.relatedSequentialForm}
                      linkedComponents={this.state.linkedComponents}
                      redirectToExternalUrl={this.state.redirectToExternalUrl}
                      setRedirectToExternalUrl={val =>
                        this.setState({ redirectToExternalUrl: val })
                      }
                      redirectUrl={this.state.redirectUrl}
                      setRedirectUrl={val => this.setState({ redirectUrl: val })}
                      submMsg={this.state.submMsg}
                      setSubmMsg={val => this.setState({ submMsg: val })}
                      canEditSubmission={this.state.canEditSubmission}
                      setCanEditSubmission={val => this.setState({ canEditSubmission: val })}
                      canReadOnly={this.state.canReadOnly}
                      setCanReadOnly={val => this.setState({ canReadOnly: val })}
                      canAddSubmission={this.state.canAddSubmission}
                      setCanAddSubmission={val => this.setState({ canAddSubmission: val })}
                      canSaveSubmission={this.state.canSaveSubmission}
                      setCanSaveSubmission={val => this.setState({ canSaveSubmission: val })}
                      autoSave={this.state.autoSave}
                      setAutoSave={val => this.setState({ autoSave: val })}
                      displayMode={this.state.displayMode}
                      setDisplayMode={val => this.setState({ displayMode: val })}
                      canAnnotateContent={this.state.canAnnotateContent}
                      setCanAnnotateContent={val => this.setState({ canAnnotateContent: false })}
                      canSubmitSubmission={this.state.canSubmitSubmission}
                      setCanSubmitSubmission={val => this.setState({ canSubmitSubmission: val })}
                      handleCancelSettings={() => this.handleCancelSettings(setOpenSettings)}
                      componentId={this.props.component_id}
                      loading={this.state.loading}
                    />

                    <CustomDialog
                      size={FormBuilderContainer.editTarget.type === 15 ? 'xl' : 'md'}
                      zIndex={true}
                      isOpen={FormBuilderContainer.onEdit}
                      key={FormBuilderContainer.editTarget.id}
                      onClose={() => {
                        FormBuilderContainer.onEdit = false;
                        FormBuilderContainer.reloadEditComponent();
                        FormBuilderContainer.notify();
                      }}
                      title={FormBuilderContainer.editTarget.text}
                      contents={
                        <ComponentConfig
                          availablePlaceholders={[
                            ...this.state.innerFormPlaceholders,
                            ...this.state.externalPlaceholders,
                          ]}
                          hasGlobalVariables={this.state.externalPlaceholders.length > 0}
                          ref={this.Config}
                          key={FormBuilderContainer.editTarget.id}
                          handleKeyChanges={error => {
                            this.setState({ error });
                          }}
                          setInnerPlaceholders={this.setInnerPlaceholders}
                        />
                      }
                      buttons={
                        <>
                          <DiscardChangesButton
                            disabled={
                              this.state.error ||
                              FormBuilderContainer.onSave ||
                              this.state.isInAIDraft
                            }
                            onDiscard={() => {
                              FormBuilderContainer.onEdit = false;
                              FormBuilderContainer.reloadEditComponent();
                              FormBuilderContainer.notify();
                            }}
                          />
                          <Button
                            disabled={this.state.error || FormBuilderContainer.onSave}
                            onClick={this.onDone}
                            variant={'contained'}
                            color={'primary'}
                          >
                            Save
                            {FormBuilderContainer.onSave && (
                              <CircularProgress size={24} className="buttonProgress" />
                            )}
                          </Button>
                        </>
                      }
                    />
                    <FormStylingDialog
                      coverImageCrop={this.state.coverImageCrop}
                      coverImageSrc={this.state.coverImageSrc}
                      openUploadDialog={openUploadDialog}
                      setOpenUploadDialog={setOpenUploadDialog}
                      onImageLoaded={this.onImageLoaded}
                      onCropChange={this.onCropChange}
                      onCropComplete={this.onCropComplete}
                      onImageDrop={this.onImageDrop}
                      onDropRejected={this.onDropRejected}
                      uploadedCoverImage={this.state.uploadedCoverImage}
                      errorCoverImageMessage={this.state.errorCoverImageMessage}
                      uploadedLogo={this.state.uploadedLogo}
                      errorLogoMessage={this.state.errorLogoMessage}
                      loadingUpload={this.state.loadingUpload}
                      deleteCoverImage={this.deleteCoverImage}
                      onLogoDrop={files => this.onLogoDrop(files)}
                      setUploadedLogo={value => this.setState({ uploadedLogo: value })}
                      setUploadIcon={value => this.setState({ uploadIcon: value })}
                    />

                    <FormExportDialog
                      openExport={openExport}
                      setOpenExport={setOpenExport}
                      exportType={this.state.exportType}
                      setExportType={val => {
                        this.setState({ exportType: val.exportType });
                      }}
                      exportFormDataAsCsv={this.exportFormDataAsCsv}
                      exportFormDataAsXLSX={this.exportFormDataAsXLSX}
                    />
                    <Grid container item xs={12} direction={'row'} style={{ padding: '0px' }}>
                      <Grid item xs={12}>
                        <FormTarget
                          coverImage={coverImageSrc}
                          coverImageCrop={coverImageCrop}
                          linkedComponent={this.state.linkedComponent}
                          redirectToExternalUrl={this.state.redirectToExternalUrl}
                          redirectUrl={this.state.redirectUrl}
                          launchSettingDialog={() => {
                            setOpenSettings(true);
                          }}
                          setInnerPlaceholders={this.setInnerPlaceholders}
                          uploadIcon={this.state.uploadIcon}
                          formTitle={useProjectStore.getState().componentName}
                          formId={this.state.form_id}
                        />
                      </Grid>
                      <StyledSnackbar
                        open={useProjectStore.getState().production && !useProjectStore.getState().canvasView}
                        message="This is a view of the production workflow. It cannot be edited and changes will not be saved."
                        severity="info"
                        onClose={() => {}}
                        autoHideDuration={null}
                      />
                      <StyledSnackbar
                        open={useProjectStore.getState().canvasView}
                        message={`You are viewing version ${useProjectStore.getState().publishedVersion}. This workflow has been published and cannot be edited.`}
                        severity="info"
                        onClose={() => {}}
                        autoHideDuration={null}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <IndividualComponentLoader />
              )}
            </Grid>
          );
        }}
      </FormContext.Consumer>
    );
  }
}

export default withParams(FormBuilderPage);
